// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RulesPane_wrapper__2rH8E","paneTitle":"RulesPane_paneTitle__2zFpE","selectLabel":"RulesPane_selectLabel__3DeUU"};